import { render } from "./FullpageInvoice.vue?vue&type=template&id=ddee8794&scoped=true"
import script from "./FullpageInvoice.vue?vue&type=script&lang=js"
export * from "./FullpageInvoice.vue?vue&type=script&lang=js"

import "./FullpageInvoice.vue?vue&type=style&index=0&id=ddee8794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddee8794"]])

export default __exports__